module.exports = __webpack_public_path__ + "img/todos.f08374ac.jpeg";